import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 相談窓口（課題 #101-12。2026-10-07 高尾さん決定）。ダッシュボードの「相談窓口」のカードから開く。
 *
 * 以前はカードから「通知」の画面に進み、相談の方法が出てこなかった（相談したい方が行き止まりになる）。
 * 文言は高尾さんの指定。組織ごとに相談先（窓口の名前・連絡先・案内文）を管理者が設定できる形は、
 * 規模を見て別に決める（その場合も、設定が無いときはこの文言を既定にする）。
 */
export default function Consult() {
  const { t } = useTranslation();
  return (
    <div className="page consult-page">
      <h1>{t('consult.title')}</h1>
      <div className="consult-card" data-testid="consult-body">
        <p>{t('consult.body')}</p>
      </div>
      <p className="report-history-back">
        <Link to="/dashboard">{t('consult.back')}</Link>
      </p>
    </div>
  );
}
